import { createTheme } from "@mui/material/styles";

import theme from "./theme";

export const fontFamily = `"Inter Tight", stolzl, "Open Sans", Arial, sans-serif`;
export const paragraphFontFamily = `"Inter", stolzl, "Open Sans", Arial, sans-serif`;

let surveyTheme = createTheme({
  ...theme,
  typography: {
    fontFamily: paragraphFontFamily,
    body1: {
      color: "#151e16",
      fontSize: 14,
    },
    body2: {
      color: "#151e16",
      fontSize: 12,
    },
    caption: {
      color: "#151e16",
    },
    subtitle1: {
      lineHeight: 1.5,
    },
    h6: {
      fontFamily: fontFamily,
      fontSize: 18,
    },
    h5: {
      fontFamily: fontFamily,
      fontSize: 20,
      lineHeight: "28px",
    },
    h4: {
      fontFamily: fontFamily,
      fontSize: 24,
      lineHeight: "32px",
    },
    h3: {
      fontFamily: fontFamily,
      fontSize: 32,
      lineHeight: "44px",
    },
    h2: {
      fontFamily: fontFamily,
      fontSize: 40,
      lineHeight: "56px",
    },
    h1: {
      fontFamily: fontFamily,
      fontSize: 45,
      margin: "revert",
    },
    button: {
      fontFamily: fontFamily,
    },
  },
});

export default surveyTheme;
